<template>
    <li class="menu-item menu-item-submenu" data-menu-toggle="hover"
        :data-container="hasPermission && locked ?'body' : false"
        :data-toggle="hasPermission && locked ? 'popover' : false"
        :data-placement="hasPermission && locked ? 'right' : false"
        :data-content="hasPermission && locked ? lockedText : false"
    >
        <a href="javascript:;" class="menu-link menu-toggle">
        <span class="svg-icon menu-icon d-flex justify-content-center mr-1">
            <i :class="icon"></i>
        </span>
            <span class="menu-text">{{ label }}</span>
            <span class="menu-label" v-show="hasPermission && !locked && badge && badge > 0">
                <span class="label label-rounded label-primary">{{ badge }}</span>
            </span>
            <i v-if="hasPermission && !locked" class="menu-arrow"></i>
            <i v-else-if="hasPermission && locked" class="pl-4 menu-icon text-center fas fa-lock"></i>
        </a>
        <div class="menu-submenu">
            <i class="menu-arrow"></i>
            <ul class="menu-subnav">
                <slot/>
            </ul>
        </div>
    </li>
</template>

<script>

export default {
    props: {
        label: String,
        icon: String,
        permission: {
            type: Boolean,
            default() {
                return null
            },
        },
        badge: String,
        lockedText: String,
    },
    computed: {
        hasPermission() {
            return this.permission !== null
        },
        locked() {
            return !this.hasPermission
        },
    },
}
</script>
